// The terracotta moment per the marketing-landing brief. A code block with
// click-to-copy. The accent is deliberately bigger here than dashboard
// discipline allows — install is the primary action of the whole page.

import { useState } from 'react'

const CMD = 'npm i -g @cairntools/cli'

export function InstallCommand() {
  const [copied, setCopied] = useState(false)
  const [failed, setFailed] = useState(false)

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(CMD)
      setCopied(true)
      setFailed(false)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      setFailed(true)
      setTimeout(() => setFailed(false), 2500)
    }
  }

  return (
    <div className="w-full max-w-xl">
      <button
        type="button"
        onClick={handleCopy}
        aria-label="Copy install command"
        className={[
          'group flex w-full items-center justify-between gap-3 rounded-md px-5 py-3 text-left font-mono text-sm transition-colors',
          copied
            ? 'bg-[var(--color-terracotta-deep)] text-[var(--color-limestone)]'
            : 'bg-[var(--color-terracotta)] text-[var(--color-limestone)] hover:bg-[var(--color-terracotta-deep)]',
        ].join(' ')}
      >
        <span aria-hidden="true" className="opacity-70">
          $
        </span>
        <span className="flex-1 truncate">{CMD}</span>
        <span className="text-xs uppercase tracking-wider opacity-80">
          {copied ? 'Copied' : failed ? 'Failed' : 'Copy'}
        </span>
      </button>
      <p className="mt-2 text-xs text-[var(--color-schist)]">
        Free during beta — bring your own OpenRouter key or use ours.
      </p>
    </div>
  )
}
